module.exports = __webpack_public_path__ + "img/archived.9b7e88a7.svg";